export class ForbiddenException extends Error implements Error {
  name = 'ForbiddenException';
  stack?: string;
  cause?: Error;
  message: string;

  constructor(message: string = 'Forbidden') {
    super(message);
  }
}
